import type React from "react";

type IconProps = React.SVGProps<SVGSVGElement> & {
	size?: number;
	color?: string;
};

export const User: React.FC<IconProps> = ({size, width, height, color = "currentColor", ...props}) => {
	return (
			<svg width={width ?? size} height={height ?? size} viewBox="0 0 22 26" fill="none"
					 xmlns="http://www.w3.org/2000/svg" {...props}>
				<path
						d="M10.9102 15.4287C15.302 15.4287 19.2257 17.4291 21.8203 20.5713C19.2257 23.7135 15.3021 25.7139 10.9102 25.7139C6.51823 25.7139 2.59457 23.7135 0 20.5713C2.59457 17.4291 6.51827 15.4287 10.9102 15.4287ZM10.9102 0C12.6151 0 14.2505 0.677221 15.4561 1.88281C16.6616 3.08839 17.3389 4.72379 17.3389 6.42871C17.3388 8.1336 16.6616 9.76907 15.4561 10.9746C14.2505 12.1801 12.6151 12.8574 10.9102 12.8574C9.20524 12.8574 7.56984 12.1801 6.36426 10.9746C5.15871 9.76907 4.4815 8.1336 4.48145 6.42871C4.48145 4.72379 5.15873 3.08839 6.36426 1.88281C7.56985 0.677221 9.20519 0 10.9102 0Z"
						fill="#8E97AD"/>
			</svg>

	);
};